// import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator"; // Poolcorp Custom Code
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";

/* Poolcorp Custom Code */
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { ProductPageFilters } from "@store/Store/Pages/ProductList/ProductListState";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import qs from "qs";

type Props = StoreHandlerProps & {
    result: ProductPageFilters;
};

type HandlerType = Handler<ProductPageFilters, Props>;
/* Poolcorp Custom Code */

export const MergeParameter: HandlerType = props => {
    const currentFilters = cloneDeep((props.getState() as ApplicationState).pages.productList.productFilters);
    /* Poolcorp Custom Code */
    const currentPageFilters = cloneDeep(
        (props.getState() as StoreApplicationState).store.pages.productList.productPageFilters,
    );
    /* Poolcorp Custom Code */
    props.result = merge(currentPageFilters, currentFilters, props.parameter);
};
export const AbortOnDuplicateFilter: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    if (props.parameter.searchWithinQueries?.filter(x => currentFilters.searchWithinQueries?.includes(x)).length) {
        return false;
    }
};

export const ResetPage: HandlerType = props => {
    if (
        props.parameter.pageSize ||
        props.parameter.sort ||
        props.parameter.pageCategoryId ||
        props.parameter.categoryId ||
        props.parameter.searchWithinQueries?.length ||
        props.parameter.brandIds?.length ||
        props.parameter.productLineIds?.length ||
        props.parameter.priceFilters?.length ||
        props.parameter.attributeValueIds?.length
    ) {
        props.result.page = undefined;
    }
};

export const AddSearchWithin: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    props.result.searchWithinQueries = currentFilters.searchWithinQueries;

    if (props.parameter.searchWithinQueries) {
        // must copy array or props don't update
        props.result.searchWithinQueries = props.result.searchWithinQueries
            ? props.result.searchWithinQueries.concat(props.parameter.searchWithinQueries)
            : props.parameter.searchWithinQueries;
    }
};

export const AddBrands: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    props.result.brandIds = currentFilters.brandIds;

    if (props.parameter.brandIds) {
        props.result.brandIds = props.parameter.brandIds.concat(props.result.brandIds || []);
    }
};

export const AddProductLines: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    props.result.productLineIds = currentFilters.productLineIds;

    if (props.parameter.productLineIds) {
        props.result.productLineIds = props.parameter.productLineIds.concat(props.result.productLineIds || []);
    }
};

export const AddPriceFilters: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    props.result.priceFilters = currentFilters.priceFilters;

    if (props.parameter.priceFilters) {
        props.result.priceFilters = props.parameter.priceFilters.concat(props.result.priceFilters || []);
    }
};

export const AddAttributeValueFilters: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    props.result.attributeValueIds = currentFilters.attributeValueIds;

    if (props.parameter.attributeValueIds) {
        props.result.attributeValueIds = props.parameter.attributeValueIds.concat(props.result.attributeValueIds || []);
    }
};

export const AddFilterCategory: HandlerType = props => {
    if (props.parameter.categoryId) {
        props.result.categoryId = props.parameter.categoryId;
    }
};

export const AddStockedItemsFilter: HandlerType = props => {
    if (props.parameter.stockedItemsOnly !== undefined) {
        props.result.stockedItemsOnly = props.parameter.stockedItemsOnly;
    }
};

export const AddPreviouslyPurchasedFilter: HandlerType = props => {
    if (props.parameter.previouslyPurchasedProducts !== undefined) {
        props.result.previouslyPurchasedProducts = props.parameter.previouslyPurchasedProducts;
    }
};

/* Poolcorp Custom Code */
export const DispatchSetProductPageFilters: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ProductList/SetProductPageFilters",
        result: props.result,
    });
};

export const DispatchSetPageFilterQuery: HandlerType = props => {
    const queryObject = {
        ...cloneDeep(props.getState().pages.productList.productFilters),
        ...cloneDeep((props.getState() as StoreApplicationState).store.pages.productList.productPageFilters),
    };
    delete queryObject.expand;
    delete queryObject.pageCategoryId;
    delete queryObject.pageProductLineId;
    delete queryObject.pageBrandId;

    const filterQuery = qs.stringify(queryObject, { arrayFormat: "comma", skipNulls: true });

    props.dispatch({
        type: "Store/Pages/ProductList/SetPageFilterQuery",
        result: filterQuery,
    });
};
/* Poolcorp Custom Code */

export const chain = [
    MergeParameter,
    AbortOnDuplicateFilter,
    ResetPage,
    AddSearchWithin,
    AddBrands,
    AddProductLines,
    AddPriceFilters,
    AddAttributeValueFilters,
    AddFilterCategory,
    AddStockedItemsFilter,
    DispatchSetProductPageFilters, // Poolcorp Custom Code
    DispatchSetPageFilterQuery, // Poolcorp Custom Code
];

const addProductPageFilters = createHandlerChainRunner(chain, "AddProductPageFilters");
export default addProductPageFilters;
